import utilits from '@/assets/utilits/request.js'
const state = {
  testData: []
}
const mutations = {}
const actions = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/enumList.js